import { Box, Typography } from "@mui/material";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import PropTypes from "prop-types";

const FileManagerEmptyState = ({ operationType }) => {
  const isExport = operationType === "EXPORT";

  const message = isExport ? "No exports found" : "No imports found";

  const description = isExport
    ? "Export files will appear here once you initiate an export operation."
    : "Import files will appear here once you upload files for import.";

  return (
    <Box
      className="file-manager-empty-state"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "48px 24px",
        textAlign: "center",
      }}
    >
      <FolderOpenIcon
        sx={{
          fontSize: 64,
          color: "text.secondary",
          opacity: 0.5,
          marginBottom: 2,
        }}
      />
      <Typography
        variant="h6"
        sx={{
          color: "text.secondary",
          marginBottom: 1,
          fontWeight: 500,
        }}
      >
        {message}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: "text.disabled",
          maxWidth: 400,
        }}
      >
        {description}
      </Typography>
    </Box>
  );
};

FileManagerEmptyState.propTypes = {
  operationType: PropTypes.oneOf(["EXPORT", "IMPORT"]).isRequired,
};

export default FileManagerEmptyState;
